import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { WarningIcon } from 'common/icons';

export type ErrorBoxProps = {
  title: React.ReactNode;
  message: React.ReactNode;
};

export const ErrorBox = ({ title, message }: ErrorBoxProps) => {
  const theme = useTheme();

  return (
    <Box
      p="1.5rem"
      border={`var(--border-size-standard) solid ${theme.palette.error.main}`}
      borderRadius="var(--border-radius-half)"
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      justifyContent="center"
    >
      <Box mb="1rem" display="flex" alignItems="center">
        <WarningIcon />
        <Box ml="0.5rem" fontWeight="bold" fontSize="1.125rem">
          {title}
        </Box>
      </Box>
      <Box>{message}</Box>
    </Box>
  );
};
